<template>
  <div class="fixed bottom-6 right-6 z-40">
    <div
      v-if="showMenu"
      class="absolute bottom-14 right-0 w-56 bg-white rounded-xl
                shadow-xl border border-gray-200 py-2 mb-2"
    >
      <p class="px-4 py-1 text-xs font-semibold text-gray-400 uppercase">
        Tours desta página
      </p>
      <button
        v-for="tour in visibleTours"
        :key="tour.id"
        @click="replayTour(tour)"
        class="w-full px-4 py-2 text-left text-sm text-gray-700
                     hover:bg-gray-50 flex items-center gap-2"
      >
        <span
          :class="isCompleted(tour.id) ? 'text-green-500' : 'text-gray-300'"
        >
          {{ isCompleted(tour.id) ? "✓" : "○" }}
        </span>
        {{ tour.label }}
      </button>
      <p v-if="!visibleTours.length" class="px-4 py-2 text-sm text-gray-400">
        Nenhum tour disponível nesta página.
      </p>
    </div>

    <button
      @click="showMenu = !showMenu"
      class="w-10 h-10 rounded-full bg-brand-600 text-white
                   shadow-lg hover:bg-brand-700 flex items-center
                   justify-center transition-all hover:scale-105"
    >
      <span class="text-lg font-semibold">?</span>
    </button>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from "vue";
import { usePage } from "@inertiajs/vue3";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

import { ONBOARDING_TOUR } from "@/tours/onboarding";
import { CREATE_PLAN_TOUR } from "@/tours/create_plan";
import { CREATE_SUBSCRIPTION_TOUR } from "@/tours/create_subscription";
import { PORTAL_FEATURE_TOUR } from "@/tours/portal_feature";
import { CUSTOMERS_INDEX_TOUR } from "@/tours/customers_index";
import { PRODUCTS_INDEX_TOUR } from "@/tours/products_index";
import { PLANS_INDEX_TOUR } from "@/tours/plans_index";
import { SUBSCRIPTIONS_INDEX_TOUR } from "@/tours/subscriptions_index";
import { INTEGRATIONS_INDEX_TOUR } from "@/tours/integrations_index";
import { API_KEYS_INDEX_TOUR } from "@/tours/api_keys_index";
import { PAYMENT_GATEWAYS_INDEX_TOUR } from "@/tours/payment_gateways_index";
import { CURRENCIES_INDEX_TOUR } from "@/tours/currencies_index";
import { LICENSE_TYPES_INDEX_TOUR } from "@/tours/license_types_index";
import { CREDIT_TYPES_INDEX_TOUR } from "@/tours/credit_types_index";
import { FEATURE_TYPES_INDEX_TOUR } from "@/tours/feature_types_index";
import { ACCOUNT_USERS_INDEX_TOUR } from "@/tours/account_users_index";
import { IMPORTS_INDEX_TOUR } from "@/tours/imports_index";

const showMenu = ref(false);

const page = usePage();
const completedTours = computed(
  () => page.props.auth?.user?.completed_tours || [],
);

const availableTours = [
  { ...ONBOARDING_TOUR, label: "Tour inicial" },
  { ...CREATE_PLAN_TOUR, label: "Criar plano" },
  { ...CREATE_SUBSCRIPTION_TOUR, label: "Criar assinatura" },
  { ...PORTAL_FEATURE_TOUR, label: "Portal do cliente" },
  { ...CUSTOMERS_INDEX_TOUR, label: "Clientes" },
  { ...PRODUCTS_INDEX_TOUR, label: "Produtos" },
  { ...PLANS_INDEX_TOUR, label: "Planos" },
  { ...SUBSCRIPTIONS_INDEX_TOUR, label: "Assinaturas" },
  { ...INTEGRATIONS_INDEX_TOUR, label: "Integrações" },
  { ...API_KEYS_INDEX_TOUR, label: "API Keys" },
  { ...PAYMENT_GATEWAYS_INDEX_TOUR, label: "Gateways" },
  { ...CURRENCIES_INDEX_TOUR, label: "Moedas" },
  { ...LICENSE_TYPES_INDEX_TOUR, label: "Tipos de licença" },
  { ...CREDIT_TYPES_INDEX_TOUR, label: "Tipos de crédito" },
  { ...FEATURE_TYPES_INDEX_TOUR, label: "Features" },
  { ...ACCOUNT_USERS_INDEX_TOUR, label: "Colaboradores" },
  { ...IMPORTS_INDEX_TOUR, label: "Importar clientes" },
];

// Só lista tours que têm pelo menos um elemento presente na página atual
// (evita clicar num tour e não acontecer nada porque os alvos não existem aqui).
const visibleTours = ref([]);

onMounted(() => {
  nextTick(() => {
    visibleTours.value = availableTours.filter((tour) =>
      tour.steps.some((s) => s.element && document.querySelector(s.element)),
    );
  });
});

const isCompleted = (id) => completedTours.value.includes(id);

const replayTour = (tour) => {
  showMenu.value = false;
  const driverObj = driver({
    showProgress: true,
    animate: true,
    overlayColor: "rgba(0, 0, 0, 0.6)",
    stagePadding: 8,
    stageRadius: 8,
    doneBtnText: "Concluir",
    nextBtnText: "Próximo",
    prevBtnText: "Anterior",
    closeBtnText: "Fechar",
    progressText: "{{current}} de {{total}}",
    steps: tour.steps.filter(
      (s) => !s.element || document.querySelector(s.element),
    ),
  });
  driverObj.drive();
};
</script>
